const latinCollator = new Intl.Collator("en", {
  numeric: true,
  sensitivity: "base",
});
const digitCollator = new Intl.Collator("en", {
  numeric: false,
  sensitivity: "base",
});

const chineseCollator = new Intl.Collator("zh-Hans-CN-u-co-pinyin", {
  numeric: true,
  sensitivity: "base",
});

const softwareSortValue = (software = {}) => String(software?.name || "").trim();

const getSoftwareSortBucket = (name = "") => {
  const firstChar = String(name || "").trim().charAt(0);

  if (!firstChar) {
    return 9;
  }

  if (/[0-9]/.test(firstChar)) {
    return 0;
  }

  if (/[A-Za-z]/.test(firstChar)) {
    return 1;
  }

  if (/[\u3400-\u9fff]/.test(firstChar)) {
    return 2;
  }

  return 3;
};

export const compareSoftwareLinksByName = (left = {}, right = {}) => {
  const leftName = softwareSortValue(left);
  const rightName = softwareSortValue(right);
  const leftBucket = getSoftwareSortBucket(leftName);
  const rightBucket = getSoftwareSortBucket(rightName);

  if (leftBucket !== rightBucket) {
    return leftBucket - rightBucket;
  }

  if (leftName && rightName) {
    let result = 0;

    if (leftBucket === 0) {
      result = digitCollator.compare(leftName, rightName);
    } else if (leftBucket === 1) {
      result = latinCollator.compare(leftName, rightName);
    } else if (leftBucket === 2) {
      result = chineseCollator.compare(leftName, rightName);
    } else {
      result = latinCollator.compare(leftName, rightName);
    }

    if (result !== 0) {
      return result;
    }
  } else if (leftName || rightName) {
    return leftName ? -1 : 1;
  }

  return String(left.id || "").localeCompare(String(right.id || ""));
};

export const sortSoftwareLinksByName = (softwareLinks = []) =>
  [...softwareLinks].sort(compareSoftwareLinksByName);
